/* eslint-disable import/no-anonymous-default-export */
import ApiRequestBuilder from './ApiRequestBuilder';
import AppContext from './Context';
import $ from 'jquery';
import Utils from './Utils';

class ApiGateway {
    constructor(protectedURL, unProtectedURL, securedURL) {
        this._url = protectedURL;
        this._unProtectedURL = unProtectedURL;
        this._securedURL = securedURL
    }
    post(service, data, callback, isProtected) {
        this._ajax('POST', service, data, callback, (isProtected === undefined || isProtected === null || isProtected === "Protected") ? this._url : (isProtected === "Secured") ? this._securedURL : this._unProtectedURL);
    }
    postFiles(service, data, callback, isProtected) {
        this._ajaxPostFiles('POST', service, data, callback, (isProtected === undefined || isProtected === null || isProtected === "Protected") ? this._url : (isProtected === "Secured") ? this._securedURL : this._unProtectedURL);
    }
    get(service, callback, isProtected) {
        this._ajax('GET', service, null, callback, (isProtected === undefined || isProtected === null || isProtected === "Protected") ? this._url : (isProtected === "Secured") ? this._securedURL : this._unProtectedURL);
    }
    getBuilder() {
        return new ApiRequestBuilder();
    }
    getOrcidData(service, callback) {
        this._ajaxGetOrcidData('GET', service, callback);
    }

    _ajax(method, service, data, callback, baseURL, tokenString, isFromRefresh) {
        var url = baseURL + service;
        let pointer = this;
        /* if(url.indexOf("__campus_ids") === -1) {
            if(url.indexOf("?") === -1) {
                url += "?";
            }
            url += "&__campus_ids=" + (AppContext.campusIds||"");
        } */
        if (data === undefined || data === null || $.trim(data).length === 0) {
            data = '';
        }
        else { data = JSON.stringify(data); }
        var headers = null;
        if (method === 'POST') {
          headers = {};
          headers['Content-Type'] = 'application/json;charset=UTF-8';
          var token="";
          if(isFromRefresh === true){
              token = tokenString || ""
            } else {
              token = (AppContext.token || '');
            }
            if (token !== undefined && token !== null && $.trim(token).length > 0) {
                headers['Authorization'] = token;
                headers['x_jwt_id'] = 1;
                headers['__campus_ids'] = 1;
            }
        }
        $.ajax({
            'url': url,
            'data': data,
            'method': method,
            'dataType': 'json',
            'headers': headers,
            'statusCode': {
                "401": function (xhr) {
                    // AppContext.alert({
                    //     Title: 'ERROR',
                    //     Text: 'Access denied'
                    // });
                    //Unautherized
                },
                "403": function (xhr) { //Forbidden
                    const refreshToken = (sessionStorage.getItem("refreshToken") || '');
                    if (refreshToken !== undefined && refreshToken !== null && $.trim(refreshToken).length > 0) {
                      const refresh = { refreshToken };
                        pointer.post("Security/refresh", refresh, (response) => {
                            try {
                              if (Utils.isUndefinedOrNull(response.data) || Utils.isNullorWhiteSpace(response.data.token)) {
                                AppContext.attachMember("token", "");
                              } else {
                                let parsedData = null
                                if(!Utils.isNullorWhiteSpace(data)){
                                  parsedData =  JSON.parse(data)
                                }
                                pointer._ajax(method, service, parsedData, callback, baseURL,'Bearer ' + decodeURIComponent(response.data.token), true);
                                AppContext.attachMember("token", 'Bearer ' + decodeURIComponent(response.data.token));
                              }
                            } catch (ex) {} finally {
                              Utils.loading("", false);
                            }
                          }, "Public");
                    }
                },
                "503": function (xhr) { //Forbidden
                    pointer.checkServiceAvailable();
                }
            }
        })
            .done(response => {
                this._invokeCallback(callback, url, response, 'SUCCESS');
            })
            .fail((response, error) => {
                this.checkServiceAvailable();
                if(response.status !== 403){
                  this._invokeCallback(callback, url, null, 'ERROR');
                }
            });
    }

    _ajaxPostFiles(method, service, data, callback, baseURL) {
        let pointer = this;
        var url = (baseURL || this._url) + service;
        var headers = null;
        if (method === 'POST') {
            headers = {};
            //headers['Content-Type'] = 'application/json;charset=UTF-8';
            var token = (AppContext.token || '');
            if (token !== undefined && token !== null && $.trim(token).length > 0) {
                headers['Authorization'] = token;
                headers['x_jwt_id'] = 1;
                headers['__campus_ids'] = 1;
            }
        }
        $.ajax({
            'url': url,
            'contentType': false,
            'processData': false,
            'data': data,
            'method': method,
            'headers': headers,
            'statusCode': {
                "401": function (xhr) { //Unautherized
                    pointer.checkServiceAvailable();
                },
                "403": function (xhr) { //Forbidden
                    pointer.checkServiceAvailable();
                },                
            }
        })
            .done(response => {
                this._invokeCallback(callback, url, response, 'SUCCESS');
            })
            .fail((response, error) => {
                pointer.checkServiceAvailable();
                pointer._invokeCallback(callback, url, null, 'ERROR');
            });
    }

    _ajaxGetOrcidData(method, service, callback) {
        var url = "https://pub.orcid.org/v2.0/" + service;
        $.ajax({
            'url': url,
            'method': method,
            'dataType': 'json',
            headers: {
                "Accept": "application/orcid+json"
            },
            'statusCode': {
                "401": function (xhr) { //Unautherized
                },
                "403": function (xhr) { //Forbidden
                }
            }
        })
            .done(response => {
                this._invokeCallback(callback, url, response, 'SUCCESS');
            })
            .fail((response, error) => {
                this.checkServiceAvailable();
                this._invokeCallback(callback, url, null, 'ERROR');
            });
    }

    async request(stateData, URL) {
        var headers = null;
        headers = {};
        headers['Content-Type'] = 'application/json;charset=UTF-8';
        var token = (AppContext.token || '');
        if (token !== undefined && token !== null && $.trim(token).length > 0) {
            headers['Authorization'] = token;
            headers['__campus_ids'] = 1;
        }
        let url = this._url + URL + stateData
        const response = await fetch(url, {
            method: "POST",
            headers: headers,
        });
        const json = await response.json();
        return json
    }

    _invokeCallback(callback, url, response, status) {
        if (callback !== undefined && callback !== null) {
            callback({
                url: url,
                status: status,
                data: response
            });
        }
    }

    // **************** to check service availability
  checkServiceAvailable = () => {
    const token = (AppContext.token || "");
    const campusIds = AppContext.campusIds || "";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        x_jwt_id: "1",
        Authorization: token,
        __campus_ids: campusIds,
      },
      body: {},
    };

    fetch(`${this._unProtectedURL}Security/isServiceAvailable`, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data?.serviceAvailable !== true) {
          AppContext.openServiceUnAvailableWindow(true);
        } else {
          AppContext.openServiceUnAvailableWindow(false);
        }
      })
      .catch((error) => {
        AppContext.openServiceUnAvailableWindow(true);
      });
  };
}

const getUrl = () => {
  const hostUrl = window.location.hostname;
  let url = "";
  switch (hostUrl) {
    case "10.5.13.52":
      url = "http://10.5.13.52:8084";
      break;
    case "10.5.5.29":
      url = "http://10.5.5.29:8081";
      break;
    case "10.5.13.210":
      url = "https://qap.christuniversity.in:81";
      break;
    case "10.5.13.206":
      url = "http://10.5.13.206:8081";
      break;
    case "qap.christuniversity.in":
      url = "https://qap.christuniversity.in:81";
      break;
    case "demoespro.christuniversity.in":
      url = "https://demoespro.christuniversity.in:81";
      break;
    case "migespro.christuniversity.in":
      url = "https://migespro.christuniversity.in:81";
      break;
    case "prepespro.christuniversity.in":
      url = "https://prepespro.christuniversity.in:81";
      break;
    case "espro.christuniversity.in":
      url = "https://espro.christuniversity.in:81";
      break;

    default:
      url = "http://localhost:8081";
      break;
  }
  return url;
};


export default new ApiGateway(`${getUrl()}/Protected/`, `${getUrl()}/Public/`, `${getUrl()}/Secured/`);
// export default new ApiGateway("http://10.5.13.52:8084/Protected/" ,"http://10.5.13.52:8084/Public/","http://10.5.13.52:8084/Secured/");
// export default new ApiGateway("http://localhost:8082/Protected/", "http://localhost:8082/Public/", "http://localhost:8082/Secured/");
// export default new ApiGateway("http://10.5.5.20:7005/Protected/", "http://10.5.5.20:7005/Public/", "http://10.5.5.20:7005/Secured/");
// export default new ApiGateway("http://10.5.13.210:8081/Protected/", "http://10.5.13.210:8081/Public/", "http://10.5.13.210:8081/Secured/");
// cloud *****
// ************ http
// export default new ApiGateway("http://13.126.53.57:8081/Protected/", "http://13.126.53.57:8081/Public/", "http://13.126.53.57:8081/Secured/");
// ************ https
// export default new ApiGateway("https://uatespro.christuniversity.in:81/Protected/", "https://uatespro.christuniversity.in:81/Public/", "https://uatespro.christuniversity.in:81/Secured/");
// ************ pre production
// export default new ApiGateway("https://espro.christuniversity.in:81/Protected/", "https://espro.christuniversity.in:81/Public/", "https://espro.christuniversity.in:81/Secured/");